<template>
  <div>
    <div class="filters-items" id="filters-items">
      <!-- <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter1"
          aria-expanded="false"
          aria-controls="category"
        >Categorias(1)</button>
        <div id="filter1" class="collapse" aria-labelledby="filter1" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck1">
              <label class="form-check-label" for="defaultCheck1">Filtro de Ar</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck2">
              <label class="form-check-label" for="defaultCheck2">Filtro de Combustível</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck3">
              <label class="form-check-label" for="defaultCheck3">Tampa para Filtro de Óleo</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck4">
              <label class="form-check-label" for="defaultCheck4">Copo para filtro separador de água</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck5">
              <label class="form-check-label" for="defaultCheck5">Filtro de Óleo</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck6">
              <label class="form-check-label" for="defaultCheck6">Filtro de cabine</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck7">
              <label
                class="form-check-label"
                for="defaultCheck7"
              >Sensores para filtros de combustíveis</label>
            </div>
          </div>
        </div>
      </div> -->

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter2"
          aria-expanded="false"
          aria-controls="category"
        >Linha de Automóvel</button>

        <div id="filter2" class="collapse" aria-labelledby="filter2" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check" v-for="line in lines" :key="line" v-if="!selectedFilters.line.value || selectedFilters.line.value === line">
              <input
                class="form-check-input"
                type="checkbox"
                :value="line"
                :id="line"
                :true-value="line"
                :false-value="''"
                v-model="selectedFilters.line.value"
                @change="clearNext(1), getFilters()"
              >
              <label class="form-check-label" :for="line">{{line}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter3"
          aria-expanded="false"
          aria-controls="category"
        >Fabricante</button>
        <div id="filter3" class="collapse" aria-labelledby="filter3" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="manufacturer in manufacturers"
              :key="manufacturer"
              v-if="!!selectedFilters.line.value && !selectedFilters.manufacturer.value || selectedFilters.manufacturer.value === manufacturer"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="manufacturer"
                :id="manufacturer"
                :true-value="manufacturer"
                :false-value="''"
                @change="clearNext(2), getFilters()"
                v-model="selectedFilters.manufacturer.value"
              >
              <label class="form-check-label" :for="manufacturer">{{manufacturer}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter4"
          aria-expanded="false"
          aria-controls="category"
        >Veículo</button>
        <div id="filter4" class="collapse" aria-labelledby="filter4" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="model in models"
              :key="model"
              v-if="!!selectedFilters.manufacturer.value && !selectedFilters.model.value || selectedFilters.model.value === model"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="model"
                :id="model"
                :true-value="model"
                :false-value="''"
                @change="clearNext(3), getFilters()"
                v-model="selectedFilters.model.value"
              >
              <label class="form-check-label" :for="model">{{model}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filte5"
          aria-expanded="false"
          aria-controls="category"
        >Versão</button>
        <div id="filte5" class="collapse" aria-labelledby="filte5" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="version in versions"
              :key="version"
              v-if="!!selectedFilters.model.value && !selectedFilters.version.value || selectedFilters.version.value === version"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="version"
                :id="version"
                :true-value="version"
                :false-value="''"
                @change="clearNext(4), getFilters()"
                v-model="selectedFilters.version.value"
              >
              <label class="form-check-label" :for="version">{{version}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter6"
          aria-expanded="false"
          aria-controls="category"
        >Motor</button>
        <div id="filter6" class="collapse" aria-labelledby="filter6" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="engine in engines"
              :key="engine"
              v-if="!!selectedFilters.version.value && !selectedFilters.engine.value || selectedFilters.engine.value === engine"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="engine"
                :id="engine"
                :true-value="engine"
                :false-value="''"
                @change="clearNext(5), getFilters()"
                v-model="selectedFilters.engine.value"
              >
              <label class="form-check-label" :for="engine">{{engine}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter7"
          aria-expanded="false"
          aria-controls="category"
        >Ano</button>
        <div id="filter7" class="collapse" aria-labelledby="filter7" data-parent="#filters-items">
          <div class="card-body">
            <div
              class="form-check"
              v-for="year in years"
              :key="year"
              v-if="!!selectedFilters.engine.value && !selectedFilters.year.value || selectedFilters.year.value === year"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="year"
                :id="year"
                :true-value="year"
                :false-value="''"
                @change="getFilters()"
                v-model="selectedFilters.year.value"
              >
              <label class="form-check-label" :for="year">{{year}}</label>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter5"
          aria-expanded="false"
          aria-controls="category"
        >Ano</button>
        <div id="filter5" class="collapse" aria-labelledby="filter5" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck14">
              <label class="form-check-label" for="defaultCheck14">Option 1</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck15">
              <label class="form-check-label" for="defaultCheck15">Option 2</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter6"
          aria-expanded="false"
          aria-controls="category"
        >Altura</button>
        <div id="filter6" class="collapse" aria-labelledby="filter6" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck16">
              <label class="form-check-label" for="defaultCheck16">Option 1</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck17">
              <label class="form-check-label" for="defaultCheck17">Option 2</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter7"
          aria-expanded="false"
          aria-controls="category"
        >Diametro externo</button>
        <div id="filter7" class="collapse" aria-labelledby="filter7" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck18">
              <label class="form-check-label" for="defaultCheck18">Option 1</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck19">
              <label class="form-check-label" for="defaultCheck19">Option 2</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter8"
          aria-expanded="false"
          aria-controls="category"
        >Rosca interna</button>
        <div id="filter8" class="collapse" aria-labelledby="filter8" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck20">
              <label class="form-check-label" for="defaultCheck20">Option 1</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck21">
              <label class="form-check-label" for="defaultCheck21">Option 2</label>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <button
          class="btn btn-link collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#filter9"
          aria-expanded="false"
          aria-controls="category"
        >Peso</button>
        <div id="filter9" class="collapse" aria-labelledby="filter9" data-parent="#filters-items">
          <div class="card-body">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck22">
              <label class="form-check-label" for="defaultCheck22">Option 1</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="defaultCheck23">
              <label class="form-check-label" for="defaultCheck23">Option 2</label>
            </div>
          </div>
        </div>
      </div>-->

      <div class="m-4 text-center">
        <a href="https://static.japanparts.com.br/Japanparts-2017-2018.zip" class="btn btn-primary">
          <i class="icon-document-download"></i> Catálogo
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { sortArrayOfStringAlphabetically } from "@/utils/array.js";

export default {
  data() {
    return {
      selectedFilters: {
        line: { name: 'line', value: '' },
        manufacturer: { name: 'manufacturer', value: '' },
        model: { name: 'model', value: '' },
        version: { name: 'version', value: '' },
        engine: { name: 'engine', value: '' },
        year: { name: 'year', value: '' }
      },

      lines: [],
      manufacturers: [],
      models: [],
      versions: [],
      engines: [],
      years: [],

      filters: [
        'line',
        'manufacturer',
        'model',
        'version',
        'engine',
        'year'
      ]
    };
  },
  props: {
    branchedFilters: {
      type: Object,
      default: {}
    },
    filtersFromUrl: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    'selectedFilters.line.value': function() {
      this.manufacturers = this.filterInvalidValues(this.branchedFilters[this.selectedFilters.line.value]);
    },

    'selectedFilters.manufacturer.value': function(filter) {
      if (filter) {
        this.models = this.filterInvalidValues(this.branchedFilters[this.selectedFilters.line.value][filter]);
      }
    },

    'selectedFilters.model.value': function(filter) {
      if (filter) {
        this.versions = this.filterInvalidValues(this.branchedFilters[this.selectedFilters.line.value][this.selectedFilters.manufacturer.value][filter]);
      }
    },

    'selectedFilters.version.value': function(filter) {
      if (filter) {
        this.engines = this.filterInvalidValues(this.branchedFilters[this.selectedFilters.line.value][this.selectedFilters.manufacturer.value][this.selectedFilters.model.value][filter]);
      }
    },

    'selectedFilters.engine.value': function(filter) {
      if (filter) {
        const vehicles = this.branchedFilters[this.selectedFilters.line.value][this.selectedFilters.manufacturer.value][this.selectedFilters.model.value][this.selectedFilters.version.value][filter];
        this.years = this.formatVehiclesYear(vehicles);
      }
    },
  },
  mounted() {
    this.getLines();
    this.loadSelectedFIltersFromURL()
  },
  methods: {
    getFilters() {
      const formattedFilters = {
        vehicle_line_detail: this.selectedFilters.line.value,
        manufacturer: this.selectedFilters.manufacturer.value,
        model: this.selectedFilters.model.value,
        version: this.selectedFilters.version.value,
        engine: this.selectedFilters.engine.value,
        year_from: this.getYearPart(0),
        year_to: this.getYearPart(1),
      }

      const filters = [
        this.selectedFilters.line.value,
        this.selectedFilters.manufacturer.value,
        this.selectedFilters.model.value,
        this.selectedFilters.version.value,
        this.selectedFilters.engine.value,
        this.selectedFilters.year.value,
      ].filter(filter => !!filter);

      this.$emit('update:selectedCarFilters', formattedFilters);
      this.$emit('update:listCarFilters', filters);
    },

    loadSelectedFIltersFromURL() {
      for (let [filterKey, filterObject] of Object.entries(this.selectedFilters)) {
        const foundFilter = this.filtersFromUrl.find(filter => filter.name === filterObject.name)

        if (foundFilter) {
          this.selectedFilters[filterKey].value = foundFilter.value;
        }
      }
      this.getFilters();
    },

    getLines() {
      this.lines = this.filterInvalidValues(this.branchedFilters);
    },

    clearNext(from) {
      this.clearFields(this.filters.slice(from));
    },

    formatVehiclesYear(vehicles) {
      let formattedYear = [];

      const formatter = (date, nullReplacer) => {
        if (date) {
          const formattedDate = new Date(date);
          return `${String(formattedDate.getUTCMonth() + 1).padStart(2, 0)}/${String(formattedDate.getUTCFullYear())}`;
        }

        return nullReplacer;
      }

      vehicles.map(vehicle => {
        if (vehicle.yearFrom || vehicle.yearTo) {
          formattedYear.push(`${formatter(vehicle.yearFrom, '<--')} | ${formatter(vehicle.yearTo, '-->')}`);
        }
      });

      return [...new Set(sortArrayOfStringAlphabetically(formattedYear))];
    },

    getYearPart(index) {
      let formattedDate;

      if (this.selectedFilters.year.value) {
        const date = this.selectedFilters.year.value.split('|')[index].trim();

        if (!['<--', '-->'].includes(date)) {
          const convertedDate = date.split('/').reverse().join('/');
          formattedDate = new Date(convertedDate).toISOString().split('T')[0];

        } else {
          formattedDate = null;
        }

      }
      return formattedDate;
    },

    clearFields(toRemove) {
      for (let [filterKey, filter] of Object.entries(this.selectedFilters)) {
        if (toRemove.includes(filter.name)) {
          this.selectedFilters[filterKey].value = '';
        }
      }
    },

    filterInvalidValues(filters) {
      const filteredFilters = Object.keys(filters).filter(filter => !!filter && filter !== 'null')
      return sortArrayOfStringAlphabetically(filteredFilters);
    },
  }
};
</script>

<style scoped>
.item {
  margin: auto 0;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/CarFilters.vue